"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  VIDEO: {
    label: 'Video',
    imageKey: 'Video'
  },
  PODCAST: {
    label: 'Podcast',
    imageKey: 'Podcast'
  },
  ANIMATION: {
    label: 'Animation',
    imageKey: 'Animation'
  },
  WEBINAR: {
    label: 'Webinar',
    imageKey: 'Webinar'
  }
};
exports.default = _default;